import axios from 'axios';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

// Fetch offers for the user
export const fetchOffers = async (username, token, { includeArchived = false } = {}) => {
    try {
        const response = await axios.get(`https://${SERVER_URL}/api/offers/${username}`, {
            params: includeArchived ? { includeArchived: 'true' } : undefined,
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        console.log('offers response', response.data);
        
        // Return both the offers array and the currency
        return {
            offers: response.data.offers || [],
            currency: response.data.currency || 'USD'
        };
    } catch (error) {
        console.error('Error fetching offers:', error);
        return { offers: [], currency: 'USD' }; // Return default values on error
    }
};

export const fetchOffersByDate = async (username, token, startDate, endDate) => {
    const response = await axios.get(`https://${SERVER_URL}/api/offers-by-date/${username}`, {
        params: { startDate, endDate },
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    });
    return {
        offers: response.data.offers || [],
        currency: response.data.currency || 'USD'
    };
};

export const handleLoginWithYouTube = (username) => {
    const url = `https://${SERVER_URL}/api/auth?userId=${username}`;
    window.open(url, '_blank');
};

export const logoutFromYt = async (username, token) => {
    // Original handleLogout logic
    try {
        const response = await axios.post(
            `https://${SERVER_URL}/api/logout-youtube`,
            {   // request body
                username: username
            },
            {   // config object with headers
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );

        if (response.data.success) {
            alert('Logged out successfully');
            return true
        } else {
            alert('Failed to log out');
            return false
        }

    } catch (error) {
        console.error('Error logging out:', error);
        alert('Error logging out');
        return false
    }
};

export const checkYouTubeLogin = async (username, token) => {
    try {
        const response = await axios.post(
            `https://${SERVER_URL}/api/check-yt-login`,
            {   // request body
                userId: username
            },
            {   // config object with headers
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response.data
    } catch (error) {
        console.error('Error checking YouTube login:', error);
    }
    return null
};

export const fetchDataByDateRange = async (username, start, end, token) => {
    try {
        const response = await axios.get(`https://${SERVER_URL}/api/sales-data-by-date`, {
            params: {
                username: username,
                startDate: start.toISOString(),
                endDate: end.toISOString(),
            },
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        const data = response.data;
        console.log('date-ranged data', data);
        return data
    } catch (error) {
        console.error('Error fetching data by date range:', error);
    }
};

    export const openBillingPortal = async (username) => {
      try {
          const response = await fetch(`https://${SERVER_URL}/api/create-billing-portal-session`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({ userId: username }), // Replace 'currentUserId' with actual user ID
          });

          if (!response.ok) {
              throw new Error('Failed to create billing portal session');
          }

          const { url } = await response.json();
          window.open(url, '_blank');
      } catch (error) {
          console.error('Error opening billing portal:', error);
      }
  };
